import { mapKeys } from 'lodash-es'

export const DAILY = 'DAILY'
export const WEEKLY = 'WEEKLY'
export const TWO_WEEKS = 'TWO_WEEKS'
export const THREE_WEEKS = 'THREE_WEEKS'
export const FOUR_WEEKS = 'FOUR_WEEKS'

export const MENU_CHANGE_DETECTION_FREQUENCIES = mapKeys(
  [
    { name: 'Daily', value: DAILY },
    { name: 'Weekly', value: WEEKLY },
    { name: '2 Weeks', value: TWO_WEEKS },
    { name: '3 Weeks', value: THREE_WEEKS },
    { name: '4 Weeks', value: FOUR_WEEKS },
  ],
  'value',
)
